module.exports = __webpack_public_path__ + "static/media/210-Mitpatient_ID_15.ba41f6cd.mp3";